import React, { useEffect } from "react";
import { Spinner } from "reactstrap";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Loader = (props) => {
  useEffect(() => {
    if (props.error) {
      toast.error(props.error, {
        position: "top-right",
        hideProgressBar: false,
        progress: undefined,
        toastId: "loader-error",
      });
    }
  }, [props.error]);

  if (props.error) {
    return (
      <div className="d-flex flex-column justify-content-center align-items-center" style={{ minHeight: "40vh" }}>
        <i className="ri-error-warning-line text-danger" style={{ fontSize: "3rem" }} />
        <p className="text-muted mt-3">{props.error}</p>
      </div>
    );
  }

  return (
    <React.Fragment>
      <div className="d-flex justify-content-center align-items-center min-vh-100">
        <Spinner color="primary" size="lg" />
      </div>
    </React.Fragment>
  );
};

export default Loader;
